import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import ShareIcon from '@material-ui/icons/Share';
import Divider from '@material-ui/core/Divider';
import { isMobile, isTablet } from 'react-device-detect';
import htmlParse from 'react-html-parser';
import AppContext from '../../../contexts/AppContext';
import './TopDebugNav.css';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  homeIcon: {
    marginTop: '-4px',
  },
  menuButtonLeft: {
    marginRight: theme.spacing(2),
    color: 'black',
  },
  menuButtonRight: {
    marginLeft: theme.spacing(2),
    color: 'black',
  },
  title: {
    fontSize: '22px',
    flexGrow: 1,
    cursor: 'pointer',
    marginLeft: theme.spacing(1),
    color: 'black',
  },
}));

export default function TopDebugNav({
  loading,
  onHomeClickHandler,
  onSaveAndShare,
  onDownloadClickHandler,
  showDownloadJson,
  onAboutClickHandler,
  sharingEnabled,
  showShare,
}) {
  const classes = useStyles();
  const { dictionnary, axl } = useContext(AppContext);

  return (
    <div className={classes.root}>
      <AppBar
        elevation={1}
        position="fixed"
        color="inherit"
        className="app-bar"
      >
        {loading && <LinearProgress />}
        <Toolbar className="nav-bar">
          <div id="title-container-flex">
            <div
              id={'title-container'}
              onClick={() => {
                onHomeClickHandler();
              }}
            >
              <div id="title-experiment">experiment</div>
              <div id="title">
                {htmlParse(dictionnary.get('top-nav-title'))}
              </div>
            </div>
          </div>

          {showDownloadJson && (
            <Button
              color="inherit"
              onClick={() => {
                onDownloadClickHandler();
              }}
            >
              Download Json
            </Button>
          )}
          {!isMobile && (
            <>
              {showShare && (
                <>
                  <Button
                    disabled={!sharingEnabled}
                    className={classes.menuButtonLeft}
                    color="inherit"
                    onClick={() => {
                      onSaveAndShare();
                    }}
                  >
                    {' '}
                    <ShareIcon />
                    &nbsp; {dictionnary.get('top-nav-save-share')}
                  </Button>
                </>
              )}
            </>
          )}
          {!isMobile && !isTablet && (
            <>
              <Button
                className={classes.menuButtonRight}
                color="inherit"
                onClick={() => {
                  onAboutClickHandler();
                }}
              >
                {' '}
                {dictionnary.get('top-nav-about')}
              </Button>
              {axl && (
                <Divider
                  style={{
                    marginLeft: 20,
                    marginRight: axl ? 55 : 0,
                    backgroundColor: 'transparent',
                  }}
                  orientation="vertical"
                  flexItem
                />
              )}
            </>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}
